import { booleanAttribute, Directive, input } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

@Directive()
export abstract class AbstractValueAccessorComponent implements ControlValueAccessor {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    readonlySignal = input<boolean, unknown>(false, {transform: booleanAttribute, alias: 'readonly'});

    /** @deprecated Use readonlySignal instead */
    get readonly(): boolean { return this.readonlySignal(); }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (_: any) => void;
    onTouched: () => void;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    abstract writeValue(obj: any): void;
}
